import { render, staticRenderFns } from "./ColourBlock.vue?vue&type=template&id=1374ab2e&scoped=true&"
import script from "./ColourBlock.vue?vue&type=script&lang=js&"
export * from "./ColourBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColourBlock.vue?vue&type=style&index=0&id=1374ab2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1374ab2e",
  null
  
)

export default component.exports